import React, { useState, useContext, useEffect } from "react";
import { useSearchParams} from "react-router-dom";
import {useTranslation} from "../../utils/hooks/translateHook.js"; 
import "./Account.css";
import api from "../../utils/API/MainApi.js";
import { CurrentUserContext } from "../../context/CurrentUserContext.js";
import hide from '../../images/hide.png';
import view from '../../images/view.png';

const API_URL = process.env.REACT_APP_API_URL;

function ResetPassword({onClose}) {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const t = useTranslation();


  const handlePasswordChange = async (e) => {
    e.preventDefault();
    
    setMessage("");
    setIsError(false);

    if (newPassword !== confirmPassword) {
      setIsError(true);
      setMessage(t("passwordsDoNotMathc") || "New Passwords do not match");
      return;
    }
    try {
      const res = await api.updateProfile(  {
        oldPassword, 
        newPassword,
      });

      setIsError(false);
      setMessage(res.message || t("successUpdatePassword"));

      setTimeout(() => {
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
        setMessage("");
        onClose();
      }, 1000)
    } catch (err) {
      console.error (err);
      setIsError(true);
      setMessage(err.message || t("errorUpdatePassword"));
    }
  };

  useEffect(() => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
  }, []);

  return (
    <div className="profile-password">
      <form onSubmit={handlePasswordChange} className="resetpassword-form" autoComplete="off">
        <ul className="password-list">
          <li class="password-wrapper">
            <p>{t("oldPassword") || "Old Password"}</p>
            <input type={showPassword ? "text" : "password"} value={oldPassword} autoComplete="current-password" onChange={(e) => setOldPassword(e.target.value)} required />
            <button type="button" className="toggle-password" onClick={() => setShowPassword(!showPassword)}>
              <img src={ showPassword ? hide : view}   style={{ width: '20px', height: '20px' }}  />
            </button>
          </li>
          <li class="password-wrapper"> 
            <p>{t("newPassword")}</p>
            <input type={showNewPassword ? "text" : "password"} value={newPassword} autoComplete="new-password" onChange={(e) => setNewPassword(e.target.value)} required/>
            <button type="button" className="toggle-password" onClick={() => setShowNewPassword(!showNewPassword)}>
              <img src={ showNewPassword ? hide : view}   style={{ width: '20px', height: '20px' }}  />
            </button>
          </li>
          <li class="password-wrapper">
            <p>{t("confirmNewPassword")}</p>
            <input type={showConfirmPassword ? "text" : "password"} value={confirmPassword} autoComplete="new-password" onChange={(e) => setConfirmPassword(e.target.value)} required/>
            <button type="button" className="toggle-password" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              <img src={ showConfirmPassword ? hide : view}   style={{ width: '20px', height: '20px' }}  />
            </button>
          </li>
        </ul>

        <div className="edit-profile-buttons">
          <button type="button" onClick={onClose}>{t("cancel")}</button>
          <button type="submit">{t("save")}</button>
        </div>
      </form>

      {message && ( <p className={`reset-message ${isError ? "error" : "success"}`}>  {message}</p>)}
    </div>
    
  );
};

export default ResetPassword;